import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-preshop-uf',
  templateUrl: './preshop-uf.component.html',
  styleUrls: ['./preshop-uf.component.css']
})
export class PreshopUfComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  arrUF: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.obterCoberturaUF();
  }

  ngOnDestroy(){
    this.tmaService.eventoFS(false);
  }

  
  obterCoberturaUF() :void{
    //verificar primeiro se possui uf/cidade  na localstorage
    if (localStorage.getItem("tmsGeoLoja") !== null) {
      var dadosGL = [];
      dadosGL = JSON.parse(localStorage.getItem('tmsGeoLoja'));
      this.tmaService.shopUF = dadosGL['uf'];
      this.tmaService.shopCidade = dadosGL['cidade'];
      
      this.router.navigate(['shop/' + dadosGL['uf'] + '/' + this.tmaService.shopCidade.replace(/\ /g, '-') ], {replaceUrl: true});
    }
    this.tmaService.listarShopUF()
    .subscribe((qRes) =>{
      this.hideCL = true;
      console.log(qRes);
      if(qRes['res'] == 'done'){
        this.arrUF = qRes['arrUF'];
      }
    })
  }

  goUF(sigla :any) :void{
    this.router.navigate(['pre-shop/cidades/' + sigla]);
    this.tmaService.shopUF = sigla;

  }
  voltar() :void{
    this.router.navigate(['home']);
  }
}
